// extracted by mini-css-extract-plugin
export default {"divider":"ShareForm_divider__kymTe"};